export default "__VITE_ASSET__RgK72qSm__"